import type { ReactElement } from 'react';
import { COMPANY_FACTS } from '@/shared/config';

/** 크게 싣는 연락처 — 나머지 사업자 정보는 오른쪽 표에 한 줄씩. */
const PHONE_LABEL = '전화번호';
const EMAIL_LABEL = 'E-Mail';
const HOURS_LABEL = '상담 운영시간';
/** 결제 안내용 정보라 회사 소개에는 싣지 않는다(푸터에는 있다). */
const ACCOUNT_LABEL = '계좌번호';

/**
 * 회사 소개 "Company" — 왼쪽에 고객센터(전화·메일·상담 시간), 오른쪽에 사업자 정보 표.
 * 값은 shared/config/company.ts(푸터와 같은 단일 원천)에서 읽는다.
 */
export const AboutCompany = (): ReactElement => {
  const phone = COMPANY_FACTS.find((fact) => fact.label === PHONE_LABEL);
  const email = COMPANY_FACTS.find((fact) => fact.label === EMAIL_LABEL);
  const hours = COMPANY_FACTS.find((fact) => fact.label === HOURS_LABEL);
  const facts = COMPANY_FACTS.filter(
    (fact) =>
      fact.label !== PHONE_LABEL &&
      fact.label !== EMAIL_LABEL &&
      fact.label !== HOURS_LABEL &&
      fact.label !== ACCOUNT_LABEL,
  );

  return (
    <section aria-labelledby="about-company-heading" className="flex flex-col gap-10 sm:gap-14">
      <header className="flex flex-col gap-4">
        <h2
          id="about-company-heading"
          className="text-[clamp(2rem,3.6vw,3.25rem)] leading-none font-bold tracking-[-0.03em]"
        >
          <span aria-hidden>Company</span>
          <span className="sr-only">회사 정보</span>
        </h2>
        <p className="text-[15px] text-muted-foreground sm:text-base">
          제작 상담과 견적 문의는 고객센터로 연락해 주세요.
        </p>
      </header>

      <div className="grid gap-12 border-t border-foreground/10 pt-10 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col gap-6">
          <h3 className="text-xl font-bold tracking-[-0.02em]">고객센터</h3>
          {phone !== undefined ? (
            <a
              href={phone.href}
              className="w-fit text-[clamp(2rem,4vw,3.25rem)] leading-none font-bold tracking-[-0.02em] tabular-nums underline-offset-8 hover:underline"
            >
              {phone.value}
            </a>
          ) : null}
          <div className="flex flex-col gap-1.5 text-[15px] text-muted-foreground">
            {hours !== undefined ? <p>{hours.value}</p> : null}
            {email !== undefined ? (
              <a
                href={email.href}
                className="w-fit text-foreground underline-offset-4 hover:underline"
              >
                {email.value}
              </a>
            ) : null}
          </div>
        </div>

        <address className="not-italic">
          <dl className="flex flex-col">
            {facts.map((fact) => (
              <div
                key={fact.label}
                className="grid grid-cols-[9.5rem_1fr] gap-3 border-b border-foreground/10 py-4 text-[15px] first:pt-0 sm:grid-cols-[11rem_1fr] sm:gap-4"
              >
                <dt className="whitespace-nowrap text-muted-foreground">{fact.label}</dt>
                <dd>{fact.value}</dd>
              </div>
            ))}
          </dl>
        </address>
      </div>
    </section>
  );
};
